<style scoped>
  .projectApproval{font-size: 16px;color: #464c5b;font-weight: bolder;margin: 35px 0 24px 0;}
  .contentClass{color: #657180;font-size: 14px;line-height: 95px;}
  .approval-list-tab{color: #333333;font-size: 14px;font-weight: bold;line-height: 61px;}
  .inputTips{display: inline-block;margin-right: 24px;font-size: 14px;color: #657180;width: 105px;text-align: right;vertical-align: top;margin-top: 8px;}
  .details-popup >>> .ivu-select{width: 440px;}
  .details-popup >>> .ivu-select-single .ivu-select-selection{border-radius: 20px;height: 40px;line-height: 38px;}
  .details-popup >>> .ivu-select-input{padding-left: 25px;font-size: 14px;color: #464c5b;}
  .details-popup >>> textarea.ivu-input{padding-left: 25px;font-size: 14px;color: #464c5b;width: 600px;border-radius: inherit;height: 140px;line-height: 38px;resize:none}
  .details-popup >>> .ivu-input{padding-left: 25px;font-size: 14px;color: #464c5b;width: 440px;border-radius: 20px;height: 40px;line-height: 38px;}
  .details-popup >>> .ivu-modal-body{font-size: 16px;}
  /*按钮*/
  .details-popup >>> .ivu-modal-footer{border-top: 0;padding: 0;}
  .details-popup >>> .ivu-modal-body{padding: 0;}
  .name{display: inline-block;font-size: 14px;color: #464c5b;margin-left: 4px;}
  .mousedischarge{border-radius: 22px;height: 44px;border: 1px solid #d7dde4;display: inline-block;padding: 0 35px 0 5px;line-height: 44px;position: relative}
  .mouseremove{display: inline-block;line-height: 44px;padding: 0 35px 0 5px;}
  .close{position: absolute;right: 0;z-index: 9999;background-color: red;width: 16px;height: 16px;border-radius: 8px;}
  .button-implement{width: 110px;height: 36px;border-radius: 18px;}
	.approval-btn{font-size:12px;background-color: #00a2e9;color: #ffffff;border-radius: 18px;margin: 0 5px;cursor: pointer;}
</style>
<template>
  <div style="text-align: center;">
    <Modal
        v-model="commentPanel.state"
        ok-text="提交"
        title="请输入评论"
        @on-ok="addComment"
    >
      <Input v-model="commentPanel.content" :autosize="{ minRows:5, maxRows:10 }" type="textarea"></Input>
      <div style="padding:5px"></div>
      <Button type="parmary"><Icon type="md-document" size="18" style="vertical-align:middle;"/><span style="vertical-align: middle;">添加附件</span></Button>
    </Modal>
    <Modal
        v-if="resultTypeList.length>0"
        v-model="modelPanel.state"
        :title="this.modelPanel.title+modelPanel.name"
        :footer-hide="true"
    >
      <component
          v-for="(item,index) in modelPanel.data"
          :key="'approvalList'+modelPanel.id+index"
          :contentIn="item.content"
					style="margin: 10px auto;"
          pattern="handle"
          :index="index"
          :is="item.name"
          @change="item.content=$event"
          @del="approval.splice($event,1)"
      ></component>
      <Divider dashed  style="margin:15px"/>
      <template v-for="(item,index) in modelPanel.approvalPeo">
        <div style="margin-bottom:15px">
          <div style="display: inline-block;width:100px;text-align: right;vertical-align:middle;">审批人</div>：
          <div style="display: inline-block">{{item.UserName}}<span :style="item.State=='已审批'?'color:#19be6b':'color:red'">（{{item.State}}）<template v-if="item.ApprovalDealTime">[{{item.ApprovalDealTime}}]</template></span></div>
        </div>
      </template>
      <Row v-for="(item,index) in modelPanel.comment" style="margin-bottom:10px">
        <Col span="6" style="text-align: right">{{item.UserName}}评论：</Col>
        <Col span="16">{{item.MessageContent}}<span style="color:#cecece">({{item.MessageCreated}} {{item.MessageCreatedTime}})</span></Col>
      </Row>
      <Button type="warning" size="small" style="margin-left:50px" @click="commentPanel.state = true">添加评论</Button>
      <span style="padding:10px"></span>
      <Button type="success" size="small" @click="exportExcel(modelPanel.data,modelPanel.name,modelPanel.createTime)">导出</Button>
      <div style="text-align: center" v-if="parseInt(modelPanel.resultState)==0&&$route.name!='approvalSubmission'">
        <Button type="success" style="margin-right:15px" v-if="item.id!='0'" v-for="(item,index) in resultTypeList" @click="setApproval(item.id)">{{item.name}}</Button>
				<userSelector
				    :userList="userList"
				    @inputChange="getUserList($event)"
				    @selected="updateAssessor($event.id);"
				>
				  <template slot="title">
				    <Button type="warning" style="margin-right:15px" @change="updateAssessor">转交</Button>
				  </template>
				</userSelector>
      </div>
    </Modal>
    <Row type="flex" justify="center" class="approval-list-tab">
      <Col span="22" style="border-bottom: 1px solid #d7dde4" >
        <Col span="24" style="margin-left: 20px;">
          <Col span="5">审批事项</Col>
          <Col span="5">案号</Col>
          <Col span="4">申请时间</Col>
          <Col span="2">审批状态</Col>
          <Col span="4">申请人</Col>
          <Col span="4"><checkbox v-model="search.finish" true-value="1" false-value="2">查看已完成审批</checkbox></Col>
        </Col>
      </Col>
    </Row>
    <Row type="flex" justify="center">
      <!--style="border-bottom: 1px solid #d7dde4"-->
      <Col span="22" v-for="(item,index) in approvalList" :key="'approvalList'+item.id" :style="index%2==0?'background-color:#f8f8f9':''">
        <Col span="24" style="margin-left: 20px;">
          <Col span="5" class="contentClass"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.name||'--'}}</span></Col>
          <Col span="5" class="contentClass"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.caseNum||'--'}}</span></Col>
          <Col span="4" class="contentClass"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.createTime||'--'}}</span></Col>
          <Col span="2" class="contentClass"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.state||'--'}}</span></Col>
          <Col span="4" class="contentClass"><span style="display:inline-block;vertical-align: middle;line-height: 1em">{{item.createPeople||'--'}}</span></Col>
					<Col span="4" class="contentClass" v-if="$route.name=='approvalSubmission'&&item.stateId.toString()=='0'">
            <Button class="approval-btn" :type="item.stateId==0?'primary':''+item.stateId==1?'success':''+item.stateId==2?'error':''" @click="state = 'handle';getModel(item,true)">查看详情</Button>
            <Button class="approval-btn" type="error" v-if="item.stateId==0" style="background-color:rgb(247, 84, 84)" @click="deleteApproval(item.id)">撤回</Button>
          </Col>
          <Col span="4" v-else class="contentClass"><Button :type="item.stateId==0?'primary':''+item.stateId==1?'success':''+item.stateId==2?'error':''" style="border-radius: 18px;width: 110px;height: 36px;" @click="getModel(item)">查看详情</Button></Col>
        </Col>
      </Col>
      <Col span="22" style="margin:40px 0 57px 0;">
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getApprovalList()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getApprovalList()"
        />
      </Col>
    </Row>
  </div>

</template>

<script>
  import approvalCheckbox from '../setting/approval/approvalCheckbox'
  import approvalDate from '../setting/approval/approvalDate'
  import approvalDateRange from '../setting/approval/approvalDateRange'
  import approvalFile from '../setting/approval/approvalFile'
  import approvalFiles from '../setting/approval/approvalFiles'
  import approvalInput from '../setting/approval/approvalInput'
  import approvalRadio from '../setting/approval/approvalRadio'
  import approvalTextarea from '../setting/approval/approvalTextarea'
  import approvalTime from '../setting/approval/approvalTime'
  import approvalTimeRange from '../setting/approval/approvalTimeRange'
  import approvalExplain from '../setting/approval/approvalExplain'
	import userSelector from "../system/userSelector";
  export default {
    name: "list",
    data: function () {
      return {
        approvalList:[],
        commentPanel:{
          state:false,
          content:'',
        },
        modelPanel:{
          state:false,
          modelId:'',
          title:'',
          id:'',
          data:[],
          comment:[],
        },
        search:{
          finish:'2',
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        resultTypeList:[],
      }
    },
    components:{
      approvalCheckbox:approvalCheckbox,
      approvalDate:approvalDate,
      approvalDateRange:approvalDateRange,
      approvalFile:approvalFile,
      approvalFiles:approvalFiles,
      approvalInput:approvalInput,
      approvalRadio:approvalRadio,
      approvalTextarea: approvalTextarea,
      approvalTime: approvalTime,
      approvalTimeRange: approvalTimeRange,
      approvalExplain: approvalExplain,
			userSelector:userSelector,
    },
    watch:{
      'search.finish':function () {
        this.getApprovalList()
      }
    },
    methods: {
      addComment:function(){
        var _this = this
        _this.send({
          headers:"L/AddApprovalMessage",
          data:{
            ApprovalId:_this.modelPanel.id,
            MessageContent:_this.commentPanel.content,
            files:[],
          },
          success:function () {
            _this.commentPanel.state = false
            _this.modelPanel.state = false
            _this.modelPanel.content = ''
            _this.$Notice.success({
              title:'系统消息',
              desc:'评论添加成功！'
            })
            _this.getApprovalList()
          }
        })
      },
			deleteApproval:function(id){
			  var _this = this
			  _this.send({
			    headers:"L/DeleteApproval",
			    confirm:true,
			    data:{
			      ApprovalId:id
			    },
			    success:function () {
			      _this.$Notice.success({
			        title:'系统消息',
			        desc:'审批撤回成功！'
			      })
			      _this.getApprovalList()
			    }
			  })
			},
			updateAssessor:function(id){
				var _this = this
				_this.send({
					headers:'L/updateAssessor',
					confirm:true,
					data:{
						AssessorUserId:id,
						ApprovalId:_this.modelPanel.id,
					},
					success:function(res){
						_this.$Notice.success({
						  title:'系统消息',
						  desc:'转交审批成功！',
						})
            _this.getApprovalList()
            _this.modelPanel.state = false
					}
				})
			},
      getResultTypeList:function(){
        var _this = this
        _this.resultTypeList = []
        _this.send({
          headers:'L/showApprovalResults',
          success:function (res) {
            for(var index in res){
              _this.resultTypeList.push({
                id:res[index].ApprovalResultsId,
                name:res[index].ApprovalResultsTitle,
              })
            }
          }
        })
      },
      setApproval:function(result){
        var _this = this
        _this.send({
          headers:'L/OperateApproval',
          confirm:true,
          data:{
            ApprovalId:_this.modelPanel.id,
            ApprovalResultsId:result,
            ApprovalModeId:_this.modelPanel.modelId,
          },
          success:function (res) {
						_this.getApprovalList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'处理成功！',
            })
            _this.modelPanel.state = false
          }
        })
      },
      getComment:function(item){
        var _this = this
        _this.modelPanel.comment = []
        _this.send({
          headers:"L/ApprovalMessage",
          data:{
            ApprovalId:item.id
          },
          success:function (res) {
            _this.modelPanel.comment = res
          }
        })
      },
      getModel:function (item) {
        this.getComment(item)
        this.modelPanel.data = []
        this.modelPanel.data = item.data
        this.modelPanel.name = item.name
        this.modelPanel.title = item.title
        this.modelPanel.id = item.id
        this.modelPanel.modelId = item.modelId
        this.modelPanel.createTime = item.createTime
        this.modelPanel.resultState = item.stateId
        this.modelPanel.approvalPeo = item.approvalPeo
        this.modelPanel.state = true
      },
      getApprovalList: function (text) {
        var _this = this
        _this.approvalList = []
        _this.send({
          headers: "L/ShowApprovalList",
          data: {
            page:_this.search.page,
            temp: _this.approvalType,
            key:text||_this.search.text,
            pageSize:_this.search.pageSize,
            finish:_this.$route.name=='approvalForwarding'?undefined:_this.search.finish,
          },
          success: function (res) {
            for(var index in res.List){
              _this.approvalList.push({
                name:res.List[index].ApprovalModeTitle,
                id:res.List[index].ApprovalId,
                createTime:res.List[index].ApprovalCreatedTime,
                title:res.List[index].CaseTitle,
                createPeople:res.List[index].UserName,
                projectId:res.List[index].CaseTitle,
                caseNum:res.List[index].CaseNum,
                state:res.List[index].ApprovalResultsTitle,
                stateId:res.List[index].ApprovalResultsId,
                data:res.List[index].ApprovalContent,
                modelId:res.List[index].ApprovalModeId,
                approvalPeo:res.List[index].ApprovalAssessorsArr,
              })
            }
            _this.search.total=res.Count
          }
        })
      },
      getUserList: function () {
        var _this = this
        _this.send({
          headers: 'C/LawList',
          data:{
            key:'',
          },
          success: function (res) {
            _this.userList = []
            for(var index in res){
              _this.userList.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            if(_this.$route.params.approval){
              _this.name = _this.$route.params.approval.name
              _this.approverList = _this.$route.params.approval.approverList
              _this.copyList = _this.$route.params.approval.copyList
              _this.approval = _this.$route.params.approval.data
              _this.approverList = _this.$route.params.approval.approverList
              _this.id = _this.$route.params.approval.id
            }
            _this.getApprovalList()
          }
        })
      },
    },
    computed:{
      approvalType:function () {
        if(this.$route.name=='approvalForwarding'){
          return 1
        }
        if(this.$route.name=='approvalHandle'){
          return 2
        }
        if(this.$route.name=='approvalSubmission'){
          return 3
        }
      }
    },
    mounted: function () {
      this.getResultTypeList()
      this.getUserList()
    }
  }
</script>
